/* @flow */
/* eslint-env es6,browser */

import connectId from '@vzm/verizon-media-connectid';
import _idpbase from './idpbase';
import { IDP_VZM, USER_ID_VERIZON } from './idpconstants';
import { isCCPAOptedOut } from '../utils/ccpautils';
import getCVars from '../utils/gputils';
import { isObject } from '../utils/coreutils';
import { logDebug } from '../utils/logger';

// key map
const VERIZON_IDP_KEYS = {
  [USER_ID_VERIZON]: 'connectid'
};

// pixelId is passed & stored in pid

/**
 * @description Implement functionality to get ID from Verizon Media
 * @module vzmidp
 */
// pixelId is passed & stored in pid

/**
 * @description Implement functionality to get ID from Verizon Media
 * @module vzmidp
 */
class _vzmidp extends _idpbase {
  _bInited: boolean;

  // flowlint-next-line unclear-type:off
  _cachedIDObj: Object;

  _enabledProviders: Array<string>;

  constructor(name: string = '') {
    super(name);
    this._bInited = false;
    this._cachedIDObj = {};
    this._enabledProviders = [];
  }

  updateConfig(config: _multiIDIDPConfig) {
    super.updateConfig(config);
    this._enabledProviders = config.enabledProviders || [];
    this.__postUpdateConfig();
  }

  __postUpdateConfig() {
    this._init();
  }

  _init() {
    if (isCCPAOptedOut() || this._bInited) {
      return;
    }

    const { _uh6: email = '' } = getCVars();
    connectId.getIds(
      {
        pixelId: this._pid,
        email
      },
      ids => {
        if (!isObject(ids) || Object.keys(ids).length === 0) {
          return;
        }
        this._cachedIDObj = ids;
        logDebug(
          `${this._name}: Loaded IDs ${JSON.stringify(this._cachedIDObj)}`
        );
        this._bInited = true;
      }
    );
  }

  /**
   * @param {string} idpKey - Additional key required to fetch individual ID value for multi ID providers
   * @returns {string} ID value
   */
  getID(idpKey: string = ''): string {
    if (!idpKey.length || !this._enabledProviders.includes(idpKey)) {
      return '';
    }
    if (!this._bInited) {
      this._init();
    }
    return this._cachedIDObj[VERIZON_IDP_KEYS[idpKey]] || '';
  }
}

const vzmidp = new _vzmidp(IDP_VZM);

export default vzmidp;
